export default __webpack_public_path__ + "static/scraps-c252cc6829d45da70a52488e96656b48.png";